import { GamepadOutlineIcon } from './GamepadOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 57E03360-C609-4F40-85D0-10A2019A1EE4
 * name gamepad-outline
 * version: 6.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/gamepad-outline.svg
 * tags
 * - Gaming / RPG 
 * - Home Automation 
 */
export const ControllerOutlineIcon = GamepadOutlineIcon;
export default ControllerOutlineIcon